import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import AuthGate from './components/AuthGate.jsx';
import TheFloor from './pages/TheFloor.jsx';
import BrowseService from './pages/BrowseService.jsx';
import TheVault from './pages/TheVault.jsx';
import Kiosk from './pages/Kiosk.jsx';
import Members from './pages/Members.jsx';
import Profile from './pages/Profile.jsx';
import NotFound from './pages/NotFound.jsx';
import { useAuth } from './lib/auth.js';
import { initLikesForUser } from './lib/likes.js';

export default function App() {
  const { user } = useAuth();

  // Whenever the signed-in user changes, refresh the in-memory likes cache.
  useEffect(() => {
    initLikesForUser(user?.id || null);
  }, [user?.id]);

  return (
    <div className="hb-app">
      <Header />
      <main className="hb-main">
        <Routes>
          {/* Public route: anyone can view a profile page. */}
          {/* Private routes: gated behind sign-in. */}
          <Route path="/" element={<AuthGate><TheFloor /></AuthGate>} />
          <Route path="/service/:serviceId" element={<AuthGate><BrowseService /></AuthGate>} />
          <Route path="/vault" element={<AuthGate><TheVault /></AuthGate>} />
          <Route path="/kiosk" element={<AuthGate><Kiosk /></AuthGate>} />
          <Route path="/members" element={<AuthGate><Members /></AuthGate>} />
          {/* Public: anyone can view a profile page (read-only for non-owners). */}
          <Route path="/u/:slug" element={<Profile />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
